import recaudosService from "../../services/recaudosService";

const state = {
    userProfile: {}
}

const mutations = {
    'SET_USER_INFO' (state, userInfo) {
        state.userProfile = userInfo
    },
}

const actions = {
    async setUser ({ commit }, user) {
        const userTrim = JSON.parse(JSON.stringify(user).replace(/"\s+|\s+"/g,'"'));
        if (user && user.client) {
            const isApproved = await updateStateRecaudo(user.client);
            userTrim.userCollected = isApproved;
        } else {
            userTrim.userCollected = false;
        }
        commit('SET_USER_INFO', userTrim);
    }
}

const getters = {}

async function updateStateRecaudo(clientProfile) {
    const dataClientToSend = {
      IdTipoIdentificacion: clientProfile?.documentTypeId == '1' ? 'CC' : clientProfile?.documentTypeId == '2' ? 'NIT': '',
      Identificacion: clientProfile?.documentNumber 
    };
    const response = await recaudosService.consultarListaRecaudos(dataClientToSend); //consultar esta lista peude traer todos pero para este caso solo necesitamos uno
    if (response && response.result && response.result[0]) {
      if (response.result[0].hasRequirement) {
        return true;
      }
    }
    return false;
}

export default {
    state,
    mutations,
    actions,
    getters
}
